import React from "react";
import { FormField } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { Translations } from "ui/Scripts/source/models/translations";
import { IModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { LockedUserInfo } from "../User/LockedUserInfo";

interface IFormFieldLockedToUserProps {
    lockedUser: IModifyUser;
    margin?: string | number;
    onUnlockAndLockToMe?: () => void;
}

export const FormFieldLockedToUser = ({ lockedUser, onUnlockAndLockToMe, margin }: IFormFieldLockedToUserProps) => {
    return (
        <FormField title={Translations.LockedToUser} margin={margin} fullWidth color="warning.main">
            <LockedUserInfo
                lockedUser={lockedUser}
                onUnlockAndLockToMe={onUnlockAndLockToMe}
            />
        </FormField>
    );
};